module.exports = __webpack_public_path__ + "static/media/image_8.8dda18f7.png";